import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
    const padding = theme.spacing(2);

    return createStyles({
        paneContent: {
            padding,
        },
        field: {
            paddingBottom: theme.spacing(),
        },
    });
});
